const emojiMap = require('./emojiMap.json');

/**
 * @param {'people'|'nature'|'food'|'activity'|'travel'|'objects'} name 
 * @returns {{ title: string, name: string, emoji: string[]}}
 */
function getCategory(name) {
  return emojiMap.categories.find(category => category.name === name);
}

/**
 * @returns {{ title: string, name: string, emoji: string[]}[]}
 */
function getCategories() {
  return emojiMap.categories;
}

const emotes = {};

const tones = {
  /**
   * Yellow
   */
  base: null,
  /**
   * Pale
   */
  tone1: '1f3fb',
  /**
   * Cream white
   */
  tone2: '1f3fc',
  /**
   * Medium brown
   */
  tone3: '1f3fd',
  /**
   * Brown
   */
  tone4: '1f3fe',
  /**
   * Dark brown / black
   */
  tone5: '1f3ff',
};

/**
 * 
 * @param {string} id The codepoint-based id, see buildEmoji.js
 * @param {string|null} diversity The skin variation of the emote
 */
function getEmote(id, diversity = tones.base) {
  const emoteId = diversity ? `${id}_${diversity}` : id;

  if (emoteId in emotes) return emotes[emoteId];
  
  return emotes[emoteId] = emojiMap.emoji.find(emote => emote.id === emoteId);
}

module.exports = {
  getCategory,
  getCategories,
  getEmote,
  tones
};
